<div class="frame">
  <div class="track-summary">
    <div class="track-summary-header">
      <mat-icon>queue_music</mat-icon>

      <span class="track-summary-title">
        TOP TRACK 5
      </span>

      <mat-icon class="help"
                matTooltip="上記カレンダーで期間指定された範囲の、曲のストリーム数TOP5（ストリーム（速報値））です。">
        help_outline
      </mat-icon>

      @if (!(dataCollectLoading$ | async)) {
      @if (
      (dataCollectionsStreams$ | async) &&
      (dataCollectionsDownloads$ | async)
      ) {
      <img class="datafix_icon"
           matTooltip="各項目において選択した期間のデータが全部揃っている場合に、チェックマークが表示されます。"
           src="./assets/data_collections.png" />
      }
      }

      <app-csv-download [id]="csvId"
                        [fileName]="csvFileName"
                        [csv]="csvData$ | async"
                        [loading]="loading$ | async"
                        [artist]="selectedArtist$ | async"></app-csv-download>
    </div>

    <div class="track-summary-date">
      {{ criteriaFrom$ | async | date: 'yyyy-MM-dd' }}
      ~
      {{ criteriaTo$ | async | date: 'yyyy-MM-dd' }}
      までの集計データ
    </div>

    <div class="track-summary-detail">
      詳細はUMAでご確認ください。
    </div>
  </div>

  <div fxLayout="column" fxLayoutGap="8px">
    @for (sale of trackSales$ | async; track sale) {
    <div>
      <app-sp-track-sale [trackSale]="sale"
                         [loading]="loading$ | async">
      </app-sp-track-sale>
    </div>
    }
  </div>

  <div class="footer-area"></div>
</div>
